/*
 *  Helpers
 */
const helpers = {
	/*
	 *  getSeparatedPrice: Used to format the pricing for presentational purposes
	 */
	getSeparatedPrice(price = "") {
		const [amount = "", cents = ""] = price.split(".");
		return {
			full: price,
			amount,
			cents
		};
	}
};

/*
 *  Variant Strategies
 */
const strategies = {
	/*
	 *  Selected: Happens when the selected prebuild (in product-card) changes its variant
	 */
	selected: {
		get({ variants, selectedId }) {
			const variant = variants.find(variant => variant.id === selectedId);
			const price = helpers.getSeparatedPrice(variant.price);

			return {
				...variant,
				price
			};
		}
	},
	/*
	 *  Default: Happens as the default behaviour
	 */
	default: {
		get({ variants }) {
			const variant = variants[0];
			const price = helpers.getSeparatedPrice(variant.price);

			return {
				...variant,
				price
			};
		}
	}
};

export default strategies;
